import React from 'react';
import { Section } from 'components/common/override-rates/Section';
import { SectionHeader } from 'components/common/override-rates/SectionHeader';
import { DiscountPanel } from 'components/common/override-rates/DiscountPanel';
import { EditProductRatesForm } from 'components/common/override-rates/EditProductRatesForm';
import { RatesConfigurationZone } from 'components/common/override-rates/RatesConfigurationZone';
import { observer } from 'mobx-react-lite';
import { useOverrideQuotedRatesPageStore } from 'store/pages/override-quoted-rates/pageStore';

export const OverrideRatesSection: React.FC = observer(() => {
  const { quotedRatesOverriderDelegate } = useOverrideQuotedRatesPageStore();
  if (!quotedRatesOverriderDelegate) return null;

  const { rateForms, discountForm, restoreInitialRates } = quotedRatesOverriderDelegate;
  return (
    <Section>
      <SectionHeader title="Override Rates" />
      <DiscountPanel originalRatesName="Quoted" restoreRates={restoreInitialRates} formController={discountForm} />
      <RatesConfigurationZone>
        {rateForms.map((form) => (
          <EditProductRatesForm
            key={form.productName}
            productName={form.productName}
            rates={form.rates}
            formController={form.formController}
          />
        ))}
      </RatesConfigurationZone>
    </Section>
  );
});
